import React from "react";

import "./Header.css";
import Logo from "./Logo";
import HeaderSteps from "./HeaderSteps";

const Header = ({
  currentPage,
  routeId,
  numInvalidElements,
  location,
  areAnyColorsOutOfStock,
}) => {
  return (
    <div className="header">
      <Logo />
      <HeaderSteps
        currentPage={currentPage}
        routeId={routeId}
        numInvalidElements={numInvalidElements}
        location={location}
        areAnyColorsOutOfStock={areAnyColorsOutOfStock}
      />
    </div>
  );
};

export default Header;
